// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","outline":"Button_outline__monpX","outlineWithBorder":"Button_outlineWithBorder__A-0j6"};